import { QUERY_KEYS } from '../../../../consts';
import { signupService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const signupAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.REGISTER,
  mutationFn: () => signupService,
  retry: 0,
});
